import React, { useEffect, useRef, useState } from 'react';
import logo from '../../assets/logo.png';
import './Workspace.css';

export default function Workspace({ view, onNavigate, onLogout, code, isAdmin, isDark, onTheme, children }) {
  const [open, setOpen] = useState(false);
  const toggle = useRef(null);
  const panel = useRef(null);
  const entries = [['dashboards', '▦', 'Dashboards'], ['agenda', '▤', 'Agenda'], ['dagagenda', '▥', 'Dagagenda'], ...(isAdmin ? [['beheer', '⚙', 'Beheer']] : [])];
  const go = value => { onNavigate(value); setOpen(false); };
  useEffect(() => {
    if (!open) return;
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    panel.current?.querySelector('button')?.focus();
    const key = e => {
      if (e.key === 'Escape') { setOpen(false); toggle.current?.focus(); }
      if (e.key === 'Tab') {
        const buttons = [...panel.current.querySelectorAll('button')];
        const first = buttons[0], last = buttons.at(-1);
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    };
    document.addEventListener('keydown', key);
    return () => { document.body.style.overflow = previous; document.removeEventListener('keydown', key); };
  }, [open]);
  return <div className="workspace">
    <div className="mobile-topbar"><button ref={toggle} type="button" className="hamburger" aria-label="Menu openen" aria-expanded={open} aria-controls="workspace-menu" onClick={() => setOpen(!open)}>☰</button><img src={logo} alt="" /><strong>Werkagenda</strong></div>
    {open && <button type="button" className="menu-scrim" aria-label="Menu sluiten" onClick={() => { setOpen(false); toggle.current?.focus(); }} />}
    <aside ref={panel} id="workspace-menu" className={`workspace-sidebar ${open ? 'is-open' : ''}`}>
      <div className="workspace-brand"><img src={logo} alt="" /><strong>Werkagenda</strong><button type="button" className="menu-close" aria-label="Menu sluiten" onClick={() => { setOpen(false); toggle.current?.focus(); }}>×</button></div>
      <button type="button" className="new-agenda-button" onClick={() => go('nieuw')}><span aria-hidden="true">＋</span> Nieuw agenda item</button>
      <span className="nav-caption">WERKPLEK</span>
      <nav aria-label="Hoofdnavigatie">{entries.map(([id, icon, label]) => <button type="button" key={id} className={`workspace-nav ${view === id ? 'selected' : ''}`} aria-current={view === id ? 'page' : undefined} onClick={() => go(id)}><span aria-hidden="true">{icon}</span>{label}</button>)}
        <button type="button" className="workspace-nav" onClick={onTheme}><span aria-hidden="true">◐</span>{isDark ? 'Lichte weergave' : 'Donkere weergave'}</button>
      </nav>
      <div className="sidebar-account"><button type="button" className={`profile-link ${view === 'profiel' ? 'selected' : ''}`} onClick={() => go('profiel')}><span className="profile-avatar">{code?.slice(0, 2)}</span><span><strong>Profiel</strong><small>{code}</small></span></button><button type="button" className="workspace-nav logout-link" onClick={onLogout}><span aria-hidden="true">↪</span>Loguit</button></div>
    </aside>
    <div className="workspace-content" inert={open ? true : undefined}>{children}</div>
  </div>;
}
